import { combineReducers } from 'redux';

import application from './application';

const reducers = combineReducers({
  application,
});

export default reducers;
